import { OrderRow } from './OrderRow';
import { useTranslate } from '@tolgee/react';
import { TradeDetailLogisticsBlock } from 'views/Conversation/Sider/useTradeDetailBusiness';
import { Button, Drawer } from 'antd';
import { useCallback, useContext } from 'react';
import { LightChatSideContext } from 'components/LightConversation/contexts/LightChatSide';
import { LogisticsInfo } from '../LogisticsInfo';
import { CloseOutlined, ExportOutlined } from '@ant-design/icons';
import { useToggle } from 'ahooks';
import { formatLogisticsInfo } from '../LogisticsInfo/utils';
import { openExternalURL } from 'utils/openExternalURL';

interface OrderLogisticsProps {
  conversation?: Conversation.Conversation;
  statusLabel: string;
  data: TradeDetailLogisticsBlock['payload'];
  sendable: boolean;
}

export const OrderLogistics = (props: OrderLogisticsProps) => {
  const { conversation, statusLabel, data, sendable } = props;
  const { t } = useTranslate();
  const [visible, { toggle: toggleVisible }] = useToggle(false);
  const contextValue = useContext(LightChatSideContext);

  const getDrawerContainer = useCallback((): HTMLElement => {
    if (contextValue?.containerRef.current) {
      return contextValue.containerRef.current;
    }
    return document.body;
  }, [contextValue]);

  return (
    <>
      <OrderRow
        title={t('trade.logisticsInfo')}
        value={statusLabel}
        extra={
          <Button type="link" size="small" className="!p-0 mt-1" onClick={toggleVisible}>
            {t('sidebar.order.action.detail')}
          </Button>
        }
      />
      <Drawer
        title={
          <div className="flex justify-between items-center">
            <span className="text-[14px] font-medium text-[var(--fett-text-primary)]">
              {t('trade.logisticsInfo')}
            </span>
            {data.kind === 'mercado' && data.sellerOrderUrl ? (
              <Button type="link" onClick={() => openExternalURL(data.sellerOrderUrl!, '__blank')}>
                {t('查看物流')}
                <ExportOutlined />
              </Button>
            ) : null}
          </div>
        }
        className="!absolute"
        placement="bottom"
        height="60vh"
        visible={visible}
        onClose={toggleVisible}
        destroyOnClose
        getContainer={getDrawerContainer}
        closable={false}
        headerStyle={{
          padding: '16px 16px 12px 16px',
          border: 'none',
        }}
        bodyStyle={{
          padding: '0 16px 16px 16px',
        }}
        extra={
          <Button type="text" size="small" onClick={toggleVisible}>
            <CloseOutlined />
          </Button>
        }
      >
        <LogisticsInfo
          conversation={conversation}
          list={formatLogisticsInfo(data)}
          sendable={sendable}
          showAll
        />
      </Drawer>
    </>
  );
};
